import { Trans, useTranslation } from 'react-i18next';
import { MdCheck, MdPriorityHigh } from 'react-icons/md';
import { useQuery as useQueryString } from '@kiper/hooks';
import {
  CalendarLayout,
  HeroCard,
  StepCards,
  SupportEmailText,
} from './components';
import { SUPPORT_EMAIL } from './constants';
import * as S from './styles';

const contentByState = {
  success: {
    heroVariant: 'success',
    HeroIconComponent: MdCheck,
    titleKey: 'welcome.title',
    descriptionKey: 'welcome.description',
    stepsHeadingKey: 'welcome.steps-heading',
    stepsKey: 'welcome.steps',
  },
  error: {
    heroVariant: 'danger',
    HeroIconComponent: MdPriorityHigh,
    titleKey: 'welcome.error-title',
    descriptionKey: 'welcome.error-description',
    stepsHeadingKey: 'welcome.error-steps-heading',
    stepsKey: 'welcome.error-steps',
  },
};

export default function CalendarWelcome() {
  const [t] = useTranslation('calendar');
  const queryStringParams = useQueryString();
  const hasError = Boolean(queryStringParams.get('error'));

  const {
    heroVariant,
    HeroIconComponent,
    titleKey,
    descriptionKey,
    stepsHeadingKey,
    stepsKey,
  } = hasError ? contentByState.error : contentByState.success;

  const handleClose = () => {
    window.close();
  };

  const translatedSteps = t(stepsKey, { returnObjects: true });
  const steps = Array.isArray(translatedSteps) ? translatedSteps : [];

  return (
    <CalendarLayout compact>
      <HeroCard
        compact
        variant={heroVariant}
        icon={<HeroIconComponent />}
        title={t(titleKey)}
      >
        <Trans
          i18nKey={descriptionKey}
          ns="calendar"
          components={{ strong: <strong /> }}
        />
      </HeroCard>

      <S.SectionHeading>{t(stepsHeadingKey)}</S.SectionHeading>
      <StepCards compact steps={steps} variant={heroVariant} />

      {!hasError && (
        <S.SubmitButton
          type="button"
          variant="contained"
          color="porterBlue"
          centered
          onClick={handleClose}
        >
          {t('welcome.close-button')}
        </S.SubmitButton>
      )}

      {hasError && (
        <S.Paragraph>
          <SupportEmailText i18nKey="welcome.support" email={SUPPORT_EMAIL} />
        </S.Paragraph>
      )}

      <S.LegalNotice>{t('welcome.trademarks')}</S.LegalNotice>
    </CalendarLayout>
  );
}
